import React, {Component} from 'react';
import {action, observable, computed} from 'mobx';
import {inject, observer} from 'mobx-react';
import {Button, FormInput, FormSelect, FormTextarea, Modal, ModalBody, ModalHeader, ModalFooter} from 'shards-react';
import FeatherIcon from 'feather-icons-react';
import {toast} from 'react-toastify';
import PageTitle from '../../../components/common/PageTitle';
import './seoAudit.scss';

const TF_OPTIONS = [
  {value: 'T', label: '사용함'},
  {value: 'F', label: '사용안함'}
];

// 쇼핑몰 카테고리 (텍스트형 SEO 샘플에서 사용)
const SHOP_CATEGORIES = [
  {key: 'fashion',     label: '의류/패션'},
  {key: 'food',        label: '식품/음식'},
  {key: 'furniture',   label: '가구/리빙'},
  {key: 'pharmacy',    label: '의약품/건강'},
  {key: 'electronics', label: '전자제품'},
  {key: 'beauty',      label: '뷰티/화장품'}
];

// 필드별 권장 샘플
// title: 모달 제목 / desc: 작성 가이드
// byCategory: true면 samples를 {카테고리키: [...]} 형태로 제공, false/없으면 단일 배열
const FIELD_SAMPLES = {
  common_page_title: {
    title: '공통 페이지 타이틀 샘플',
    desc: '브라우저 탭과 검색 결과에 가장 먼저 노출되는 제목입니다. [쇼핑몰명] 자리에 본인 브랜드명을 넣고, 핵심 키워드와 슬로건을 함께 작성하세요. 30~60자 권장.',
    byCategory: true,
    samples: {
      fashion: [
        {label: '브랜드 + 슬로건',   value: '[쇼핑몰명] - 트렌디한 데일리룩 셀렉트샵'},
        {label: '브랜드 + 카테고리', value: '[쇼핑몰명] | 여성·남성 의류, 신발, 액세서리 전문몰'},
        {label: '시즌/프로모션',     value: '여름 신상 30% 할인 - [쇼핑몰명] 시즌오프'}
      ],
      food: [
        {label: '브랜드 + 슬로건',   value: '[쇼핑몰명] - 산지직송 신선식품 전문몰'},
        {label: '브랜드 + 카테고리', value: '[쇼핑몰명] | 유기농·친환경 프리미엄 식재료'},
        {label: '슬로건 + 브랜드',   value: '건강한 한 끼, [쇼핑몰명]'}
      ],
      furniture: [
        {label: '브랜드 + 슬로건',   value: '[쇼핑몰명] - 감각적인 홈 인테리어 가구'},
        {label: '브랜드 + 카테고리', value: '[쇼핑몰명] | 침실·거실·주방 가구 전문몰'},
        {label: '슬로건 + 브랜드',   value: '내 공간을 바꾸는 데일리 리빙숍, [쇼핑몰명]'}
      ],
      pharmacy: [
        {label: '브랜드 + 슬로건',   value: '[쇼핑몰명] - 건강기능식품·영양제 전문몰'},
        {label: '브랜드 + 카테고리', value: '[쇼핑몰명] | 비타민, 프로바이오틱스, 오메가3'},
        {label: '신뢰 강조형',       value: '전문가가 추천하는 [쇼핑몰명] 건강관리'}
      ],
      electronics: [
        {label: '브랜드 + 슬로건',   value: '[쇼핑몰명] - 스마트한 일상의 IT·가전 셀렉트'},
        {label: '브랜드 + 카테고리', value: '[쇼핑몰명] | 노트북, 스마트폰, 가전제품'},
        {label: '신뢰/혜택 강조형', value: '정품·최저가 보장, 무이자 12개월 - [쇼핑몰명]'}
      ],
      beauty: [
        {label: '브랜드 + 슬로건',   value: '[쇼핑몰명] - 데일리 케어부터 메이크업까지'},
        {label: '브랜드 + 카테고리', value: '[쇼핑몰명] | 스킨케어·색조·헤어/바디 전문'},
        {label: '특화 카테고리형',   value: '민감 피부 화장품 큐레이션 [쇼핑몰명]'}
      ]
    }
  },
  common_page_meta_description: {
    title: '공통 페이지 메타 설명 샘플',
    desc: '검색 결과 제목 아래 표시되는 요약 문구입니다. 핵심 가치와 차별점을 50~160자 사이로 작성하세요. [쇼핑몰명]은 본인 브랜드명으로 교체하세요.',
    byCategory: true,
    samples: {
      fashion: [
        {label: '브랜드 소개형', value: '[쇼핑몰명]은 매 시즌 트렌드를 반영한 데일리룩과 시그니처 아이템을 제안하는 온라인 패션 셀렉트샵입니다. 여성·남성·키즈 의류부터 신발, 액세서리까지 한 곳에서 만나보세요.'},
        {label: '혜택 강조형',   value: '신상품 매주 업데이트, 회원가입 시 10% 즉시 할인 쿠폰 지급. 7일 무료 교환·반품으로 부담 없이 쇼핑하세요.'}
      ],
      food: [
        {label: '브랜드 소개형', value: '[쇼핑몰명]은 전국 산지에서 직배송되는 신선한 농수산물과 검증된 유기농 식재료를 합리적인 가격으로 제공합니다. 안심하고 즐기는 건강한 식탁을 만들어드립니다.'},
        {label: '혜택 강조형',   value: '오늘 주문하면 내일 도착, 새벽배송으로 언제나 신선하게. 정기구독 시 최대 20% 할인 혜택을 누려보세요.'}
      ],
      furniture: [
        {label: '브랜드 소개형', value: '침실, 거실, 주방, 서재까지. [쇼핑몰명]의 큐레이션된 가구와 리빙 소품으로 일상의 공간을 완성하세요. 무료 배송 및 무료 설치 서비스를 제공합니다.'},
        {label: '서비스 강조형', value: '감각적 디자인과 합리적 가격을 모두 만족하는 가구 전문몰. 3D 가상 배치로 미리 보고 결정하세요.'}
      ],
      pharmacy: [
        {label: '브랜드 소개형', value: '[쇼핑몰명]은 건강기능식품·영양제·홍삼·비타민 등 검증된 제품만을 엄선해 제공하는 헬스케어 전문몰입니다. 약사·영양사 상담으로 나에게 맞는 제품을 추천받으세요.'},
        {label: '신뢰 강조형',   value: '정품 보증, 빠른 배송, 정기구독 할인까지. 가족의 건강을 챙기는 첫 번째 선택, [쇼핑몰명]에서 시작하세요.'}
      ],
      electronics: [
        {label: '브랜드 소개형', value: '[쇼핑몰명]은 노트북·스마트폰·생활가전·주방가전 등 인기 IT·가전 제품을 정품·최저가로 제공합니다. 무이자 할부 12개월, 당일 배송 가능합니다.'},
        {label: '신뢰 강조형',   value: '공식 인증 판매처, 무상 A/S 보장. 새 제품 출시 알림 신청 시 사전예약 혜택과 적립금을 지급합니다.'}
      ],
      beauty: [
        {label: '브랜드 소개형', value: '스킨케어, 색조, 헤어, 바디까지. 피부 타입별 큐레이션된 [쇼핑몰명]의 뷰티 컬렉션으로 나만의 데일리 루틴을 완성하세요. 모든 제품 샘플 무료 증정.'},
        {label: '혜택 강조형',   value: '민감 피부도 안심, 임상 테스트 완료 제품만. 신제품 리뷰 작성 시 적립금 5,000원, 첫 구매 시 무료 배송.'}
      ]
    }
  },
  favicon: {
    title: '파비콘 URL 샘플',
    desc: '브라우저 탭 아이콘 이미지입니다. 32x32 또는 64x64 PNG, 정사각형 권장. 로고를 단순화한 심볼 사용을 추천합니다.',
    samples: [
      {label: 'PNG 예시', value: 'https://example.com/favicon-32x32.png'},
      {label: 'ICO 예시', value: 'https://example.com/favicon.ico'}
    ]
  },
  sns_share_image: {
    title: 'SNS 공유 이미지 (Open Graph) 샘플',
    desc: '카카오톡/페이스북/트위터 등에서 링크 공유 시 표시되는 미리보기 이미지입니다. 1200x630px JPG/PNG 권장.',
    samples: [
      {label: '예시 URL', value: 'https://example.com/og-image-1200x630.png'}
    ]
  },
  robots_text: {
    title: 'robots.txt 권장 샘플 (PC)',
    desc: '검색엔진 크롤러의 접근 규칙입니다. "Disallow: /" 는 전체 차단을 의미하므로 운영 중에는 사용 금지.',
    samples: [
      {
        label: '표준(권장)',
        value: 'User-agent: *\nDisallow: /admin/\nDisallow: /member/\nDisallow: /order/\nDisallow: /myshop/\nDisallow: /cart/\n\nSitemap: https://example.com/sitemap.xml'
      },
      {
        label: '모든 봇 허용 (최소)',
        value: 'User-agent: *\nAllow: /'
      },
      {
        label: '특정 봇만 허용',
        value: 'User-agent: Googlebot\nAllow: /\n\nUser-agent: Yeti\nAllow: /\n\nUser-agent: *\nDisallow: /'
      }
    ]
  },
  mobile_robots_text: {
    title: 'robots.txt 권장 샘플 (모바일)',
    desc: '모바일 버전 robots.txt. 일반적으로 PC와 동일하게 설정합니다.',
    samples: [
      {
        label: '표준(권장)',
        value: 'User-agent: *\nDisallow: /admin/\nDisallow: /member/\nDisallow: /order/\nDisallow: /myshop/\nDisallow: /cart/\n\nSitemap: https://m.example.com/sitemap.xml'
      }
    ]
  },
  llms_text: {
    title: 'llms.txt 권장 샘플',
    desc: 'ChatGPT/Perplexity 등 AI 크롤러의 학습/인덱싱을 제어합니다. 학습 차단을 원하면 Disallow, 허용은 Allow.',
    samples: [
      {
        label: '학습 차단',
        value: 'User-agent: GPTBot\nDisallow: /\n\nUser-agent: ChatGPT-User\nDisallow: /\n\nUser-agent: ClaudeBot\nDisallow: /\n\nUser-agent: PerplexityBot\nDisallow: /'
      },
      {
        label: '학습 허용',
        value: 'User-agent: GPTBot\nAllow: /\n\nUser-agent: ChatGPT-User\nAllow: /\n\nUser-agent: ClaudeBot\nAllow: /'
      }
    ]
  },
  missing_page_redirect_url: {
    title: '404 리다이렉션 경로 샘플',
    desc: '없는 페이지 접근 시 이동할 경로. 메인이나 카테고리 페이지로 보내는 것이 일반적.',
    samples: [
      {label: '메인 페이지', value: '/'},
      {label: '상품 카테고리', value: '/product/list.html'},
      {label: '404 안내 페이지', value: '/page/notfound'}
    ]
  }
};

// 진단 룰
// severity: 'error' (필수/심각) | 'warn' (권장) | 'info'
// section: 룰이 속한 설정 섹션 탭 / field: 해당 입력 필드 name (포커스/스크롤 대상)
const RULES = [
  {
    key: 'common_page_title',
    label: '공통 페이지 타이틀',
    section: 'basic',
    field: 'common_page_title',
    severity: 'error',
    test: (s) => !!(s.common_page_title && s.common_page_title.trim().length > 0),
    msg: '공통 페이지 타이틀이 비어 있습니다. 검색엔진 노출을 위해 반드시 입력하세요.'
  },
  {
    key: 'common_page_title_length',
    label: '타이틀 길이 (10~60자 권장)',
    section: 'basic',
    field: 'common_page_title',
    severity: 'warn',
    test: (s) => {
      const v = (s.common_page_title || '').trim();
      return v.length >= 10 && v.length <= 60;
    },
    msg: '타이틀은 10~60자 사이가 권장됩니다. (현재: {len}자)'
  },
  {
    key: 'common_page_meta_description',
    label: '공통 페이지 메타 설명',
    section: 'basic',
    field: 'common_page_meta_description',
    severity: 'error',
    test: (s) => !!(s.common_page_meta_description && s.common_page_meta_description.trim().length > 0),
    msg: '메타 설명이 비어 있습니다. 검색 결과에 노출될 요약 문구를 입력하세요.'
  },
  {
    key: 'common_page_meta_description_length',
    label: '메타 설명 길이 (50~160자 권장)',
    section: 'basic',
    field: 'common_page_meta_description',
    severity: 'warn',
    test: (s) => {
      const v = (s.common_page_meta_description || '').trim();
      return v.length >= 50 && v.length <= 160;
    },
    msg: '메타 설명은 50~160자 사이가 권장됩니다. (현재: {len}자)'
  },
  {
    key: 'favicon',
    label: '파비콘',
    section: 'basic',
    field: 'favicon',
    severity: 'warn',
    test: (s) => !!(s.favicon && /^(https?:)?\/\//.test(s.favicon)),
    msg: '파비콘이 설정되어 있지 않습니다. 브랜드 인지도와 신뢰성을 위해 설정하세요.'
  },
  {
    key: 'sns_share_image',
    label: 'SNS 공유 이미지(OG)',
    section: 'sns',
    field: 'sns_share_image',
    severity: 'warn',
    test: (s) => !!(s.sns_share_image && /^(https?:)?\/\//.test(s.sns_share_image)),
    msg: 'SNS 공유 이미지가 없습니다. 카카오톡/페이스북 공유 시 미리보기 이미지가 표시되지 않습니다.'
  },
  {
    key: 'use_google_search_console',
    label: '구글 서치 콘솔',
    section: 'search',
    field: 'google_search_console',
    severity: 'warn',
    test: (s) => s.use_google_search_console === 'T' && !!(s.google_search_console && s.google_search_console.trim()),
    msg: '구글 서치 콘솔이 미설정 상태입니다. 검색 성과 추적을 위해 등록하세요.'
  },
  {
    key: 'use_naver_search_advisor',
    label: '네이버 서치 어드바이저',
    section: 'search',
    field: 'naver_search_advisor',
    severity: 'warn',
    test: (s) => s.use_naver_search_advisor === 'T' && !!(s.naver_search_advisor && s.naver_search_advisor.trim()),
    msg: '네이버 서치 어드바이저가 미설정 상태입니다. 국내 검색 노출을 위해 등록하세요.'
  },
  {
    key: 'use_sitemap_auto_update',
    label: '사이트맵 자동 갱신',
    section: 'robots',
    field: 'use_sitemap_auto_update',
    severity: 'error',
    test: (s) => s.use_sitemap_auto_update === 'T',
    msg: '사이트맵 자동 갱신이 OFF 상태입니다. 검색엔진 색인을 위해 ON 권장.'
  },
  {
    key: 'use_rss',
    label: 'RSS 피드',
    section: 'robots',
    field: 'use_rss',
    severity: 'info',
    test: (s) => s.use_rss === 'T',
    msg: 'RSS 피드가 OFF 상태입니다.'
  },
  {
    key: 'robots_text',
    label: '검색로봇 접근 제어 (PC)',
    section: 'robots',
    field: 'robots_text',
    severity: 'warn',
    test: (s) => {
      const v = (s.robots_text || '').toLowerCase();
      // 비어있어도 카페24 기본값이 있으나, "Disallow: /" 같은 전체 차단 검사
      if (!v) return true;
      return !/disallow:\s*\/\s*$/m.test(v);
    },
    msg: 'robots.txt에 전체 경로 차단(Disallow: /)이 설정되어 있어 검색엔진 노출이 막혀 있습니다.'
  },
  {
    key: 'mobile_robots_text',
    label: '검색로봇 접근 제어 (모바일)',
    section: 'robots',
    field: 'mobile_robots_text',
    severity: 'warn',
    test: (s) => {
      const v = (s.mobile_robots_text || '').toLowerCase();
      if (!v) return true;
      return !/disallow:\s*\/\s*$/m.test(v);
    },
    msg: '모바일 robots.txt에 전체 경로 차단이 설정되어 있습니다.'
  }
];

@inject(({teamUser}) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({common}) => ({getDoc: common.getDoc, updateDoc: common.updateDoc}))
@observer
class SeoAudit extends Component {

  @observable settings = {};
  originalSettings = {};
  @observable isLoading = false;
  @observable isSaving = false;
  @observable activeSection = 'basic'; // basic | search | sns | robots | redirect | html | og
  @observable highlightField = null;
  highlightTimer = null;
  @observable sampleModal = {open: false, field: null};
  @observable selectedSampleCategory = 'fashion';

  componentDidMount() {
    this.loadSettings();
  }

  @action
  loadSettings = async () => {
    if (!this.props.me || !this.props.me.store) return;
    this.isLoading = true;
    try {
      const param = {
        store_id: this.props.me.store._id,
        shopNo: this.props.me.selShopNo || 1
      };
      const res = await this.props.getDoc('getCafe24SeoSetting', param);
      if (res && res.data) {
        this.settings = res.data || {};
        this.originalSettings = JSON.parse(JSON.stringify(this.settings));
      } else {
        toast.error('SEO 설정 조회에 실패했습니다.');
      }
    } catch (e) {
      console.error(e);
      toast.error('SEO 설정 조회 중 오류가 발생했습니다.');
    } finally {
      this.isLoading = false;
    }
  };

  // 유료 사용자만 설정 저장/편집 가능 (진단은 무료 허용)
  // 14일 무료 체험(shop.orderType === 'free')은 유료 기능 사용 불가
  get isPaidUser() {
    const me = this.props.me;
    if (!me || !me.isPaidShop) return false;
    if (me.shop && me.shop.orderType === 'free') return false;
    return true;
  }

  saveSettings = async () => {
    if (!this.props.me || !this.props.me.store) return;
    if (!this.isPaidUser) {
      toast.warn('SEO 설정 저장은 유료 플랜 전용 기능입니다.');
      return;
    }
    this.isSaving = true;
    const current = this.toPlain(this.settings);
    const original = this.originalSettings || {};
    // 변경된 필드만 PUT — 카페24가 발급한 //ecimg... 같은 protocol-relative URL 재전송 방지
    const dirty = {};
    Object.keys(current).forEach(k => {
      if (JSON.stringify(current[k]) !== JSON.stringify(original[k])) {
        dirty[k] = current[k];
      }
    });
    const param = Object.assign({
      store_id: this.props.me.store._id,
      shopNo: this.props.me.selShopNo || 1
    }, dirty);

    // 카페24가 Invalid URL 로 거부하지 않도록 빈/잘못된 URL 필드는 사전 제외 (백업 방어)
    ['favicon', 'sns_share_image'].forEach(k => {
      if (!(k in param)) return;
      const s = typeof param[k] === 'string' ? param[k].trim() : '';
      if (!/^https?:\/\/.+/i.test(s)) delete param[k];
    });
    ['missing_page_redirect_url', 'mobile_missing_page_redirect_url'].forEach(k => {
      if (!(k in param)) return;
      if (typeof param[k] !== 'string' || param[k].trim() === '') delete param[k];
    });

    // 실제 변경된 설정이 하나도 없으면 PUT 생략
    const dirtyKeys = Object.keys(param).filter(k => k !== 'store_id' && k !== 'shopNo');
    if (dirtyKeys.length === 0) {
      this.isSaving = false;
      toast.info('변경된 항목이 없습니다.');
      return;
    }

    this.props.updateDoc('updateCafe24SeoSetting', param, (res, errors) => {
      this.isSaving = false;
      if (errors && errors.length > 0) {
        toast.error(errors[0].message || 'SEO 설정 저장에 실패했습니다.');
        return;
      }
      if (!res) {
        toast.error('SEO 설정 저장 응답이 없습니다.');
        return;
      }
      toast.success('SEO 설정이 저장되었습니다.');
      if (res.data && typeof res.data === 'object') {
        this.settings = res.data;
        this.originalSettings = JSON.parse(JSON.stringify(this.settings));
      }
    });
  };

  toPlain = (obj) => JSON.parse(JSON.stringify(obj || {}));

  @action
  onChange = (name, value) => {
    this.settings[name] = value;
  };

  // ===== Schema.org JSON-LD (리뷰 리치 스니펫) =====
  RICH_SNIPPET_MARKER_START = '<!-- ONREPLE_RICH_SNIPPET_START -->';
  RICH_SNIPPET_MARKER_END   = '<!-- ONREPLE_RICH_SNIPPET_END -->';

  buildRichSnippetBlock = () => {
    // 카페24의 상품상세 페이지에서 사용 가능한 스크립트 변수 활용
    // (변수 미가용 환경에서도 빈 값으로 자연스럽게 처리되도록 fallback)
    return [
      this.RICH_SNIPPET_MARKER_START,
      '<script type="application/ld+json">',
      '{',
      '  "@context": "https://schema.org/",',
      '  "@type": "Product",',
      '  "name": "{$product.product_name|default:""}",',
      '  "image": "{$product.detail_image|default:""}",',
      '  "description": "{$product.simple_description|default:""}",',
      '  "brand": { "@type": "Brand", "name": "{$product.brand_name|default:""}" },',
      '  "aggregateRating": {',
      '    "@type": "AggregateRating",',
      '    "ratingValue": "{$product.review_avg_rating|default:"0"}",',
      '    "reviewCount": "{$product.review_count|default:"0"}"',
      '  }',
      '}',
      '</script>',
      this.RICH_SNIPPET_MARKER_END
    ].join('\n');
  };

  @action
  injectRichSnippet = () => {
    if (!this.isPaidUser) {
      toast.warn('구글 검색 별점·리뷰 노출은 유료 플랜 전용 기능입니다.');
      return;
    }
    const cur = this.settings.header_tag || '';
    if (cur.includes(this.RICH_SNIPPET_MARKER_START)) {
      toast.info('이미 별점·리뷰 검색노출이 적용되어 있습니다.');
      return;
    }
    const block = this.buildRichSnippetBlock();
    this.settings.header_tag = cur ? `${cur.trim()}\n\n${block}` : block;
    toast.success('별점·리뷰 검색노출 코드가 Head HTML(PC)에 추가되었습니다. 저장 버튼을 눌러야 카페24에 반영됩니다.');
  };

  @action
  removeRichSnippet = () => {
    if (!this.isPaidUser) {
      toast.warn('별점·리뷰 검색노출 변경은 유료 플랜 전용 기능입니다.');
      return;
    }
    const cur = this.settings.header_tag || '';
    if (!cur.includes(this.RICH_SNIPPET_MARKER_START)) {
      toast.info('적용된 별점·리뷰 검색노출이 없습니다.');
      return;
    }
    // 마커 사이의 블록을 정규식으로 제거 (블록 + 앞뒤 공백)
    const startEsc = this.RICH_SNIPPET_MARKER_START.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    const endEsc = this.RICH_SNIPPET_MARKER_END.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    const re = new RegExp(`\\s*${startEsc}[\\s\\S]*?${endEsc}\\s*`, 'g');
    const next = cur.replace(re, '\n').replace(/\n{3,}/g, '\n\n').trim();
    this.settings.header_tag = next;
    toast.success('별점·리뷰 검색노출 코드가 제거되었습니다.');
  };

  @action
  jumpToRule = (rule) => {
    if (!rule || !rule.section || !rule.field) return;
    this.activeSection = rule.section;
    this.highlightField = rule.field;
    // 섹션이 다시 그려진 다음 스크롤/포커스
    setTimeout(() => {
      const el = document.querySelector(`[data-seo-field="${rule.field}"]`);
      if (el) {
        el.scrollIntoView({behavior: 'smooth', block: 'center'});
        const input = el.querySelector('input, textarea, select');
        if (input) input.focus();
      }
    }, 50);
    // 하이라이트 자동 해제
    if (this.highlightTimer) clearTimeout(this.highlightTimer);
    this.highlightTimer = setTimeout(() => { this.highlightField = null; }, 2000);
  };

  componentWillUnmount() {
    if (this.highlightTimer) clearTimeout(this.highlightTimer);
  }

  @action
  openSample = (field) => {
    this.sampleModal = {open: true, field};
  };

  @action
  closeSample = () => {
    this.sampleModal = {open: false, field: null};
  };

  @action
  applySample = (field, value) => {
    this.settings[field] = value;
    this.closeSample();
    toast.success('샘플이 적용되었습니다. 저장 버튼을 눌러야 반영됩니다.');
  };

  copySample = (value) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(
        () => toast.success('샘플이 클립보드에 복사되었습니다.'),
        () => toast.error('복사에 실패했습니다.')
      );
    } else {
      // fallback
      const ta = document.createElement('textarea');
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); toast.success('샘플이 클립보드에 복사되었습니다.'); }
      catch (e) { toast.error('복사에 실패했습니다.'); }
      document.body.removeChild(ta);
    }
  };

  @computed
  get auditResults() {
    const results = RULES.map(rule => {
      const passed = !!rule.test(this.settings);
      let msg = rule.msg;
      if (rule.key.endsWith('_length')) {
        const fieldKey = rule.key.replace('_length', '');
        msg = msg.replace('{len}', ((this.settings[fieldKey] || '').trim().length));
      }
      return {...rule, passed, msg};
    });
    return results;
  }

  @computed
  get auditSummary() {
    const failed = this.auditResults.filter(r => !r.passed);
    return {
      total: this.auditResults.length,
      passed: this.auditResults.length - failed.length,
      errors: failed.filter(r => r.severity === 'error').length,
      warns: failed.filter(r => r.severity === 'warn').length,
      infos: failed.filter(r => r.severity === 'info').length
    };
  }

  @computed
  get scoreLevel() {
    const {total, passed} = this.auditSummary;
    const pct = total === 0 ? 100 : Math.round((passed / total) * 100);
    if (pct >= 90) return {pct, label: '우수', color: '#15803D'};
    if (pct >= 70) return {pct, label: '양호', color: '#CA8A04'};
    if (pct >= 50) return {pct, label: '주의', color: '#EA580C'};
    return {pct, label: '개선 필요', color: '#DC2626'};
  }

  renderRuleIcon = (rule) => {
    if (rule.passed) return <FeatherIcon icon="check-circle" size="16" className="seo-rule__icon seo-rule__icon--ok"/>;
    if (rule.severity === 'error') return <FeatherIcon icon="x-circle" size="16" className="seo-rule__icon seo-rule__icon--error"/>;
    if (rule.severity === 'warn') return <FeatherIcon icon="alert-triangle" size="16" className="seo-rule__icon seo-rule__icon--warn"/>;
    return <FeatherIcon icon="info" size="16" className="seo-rule__icon seo-rule__icon--info"/>;
  };

  renderFieldHeader = (name, label) => {
    const hasSample = !!FIELD_SAMPLES[name];
    return (
      <div className="seo-field__header">
        <label className="seo-field__label">{label}</label>
        {hasSample && (
          <button type="button" className="seo-field__sample-btn"
                  onClick={() => this.openSample(name)}>
            <FeatherIcon icon="book-open" size="12"/>
            <span>권장 샘플 보기</span>
          </button>
        )}
      </div>
    );
  };

  renderTextField = (name, label, helper, opts = {}) => {
    const disabled = !this.isPaidUser;
    return (
      <div className={`seo-field${this.highlightField === name ? ' is-highlight' : ''}`} data-seo-field={name}>
        {this.renderFieldHeader(name, label)}
        {opts.textarea ? (
          <FormTextarea value={this.settings[name] || ''} rows={opts.rows || 4}
                        disabled={disabled}
                        onChange={(e) => this.onChange(name, e.target.value)}/>
        ) : (
          <FormInput value={this.settings[name] || ''}
                     disabled={disabled}
                     onChange={(e) => this.onChange(name, e.target.value)}/>
        )}
        {helper && <div className="seo-field__helper">{helper}</div>}
      </div>
    );
  };

  renderToggleField = (name, label, helper) => {
    const disabled = !this.isPaidUser;
    return (
      <div className={`seo-field${this.highlightField === name ? ' is-highlight' : ''}`} data-seo-field={name}>
        {this.renderFieldHeader(name, label)}
        <FormSelect value={this.settings[name] || 'F'}
                    disabled={disabled}
                    onChange={(e) => this.onChange(name, e.target.value)}>
          {TF_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </FormSelect>
        {helper && <div className="seo-field__helper">{helper}</div>}
      </div>
    );
  };

  renderSampleModal = () => {
    const {open, field} = this.sampleModal;
    if (!open || !field) return null;
    const sample = FIELD_SAMPLES[field];
    if (!sample) return null;
    const isMultiline = (v) => typeof v === 'string' && v.indexOf('\n') >= 0;

    // 카테고리 분기: byCategory면 선택된 카테고리의 샘플, 아니면 단일 배열
    let currentSamples = [];
    if (sample.byCategory) {
      const cat = this.selectedSampleCategory;
      currentSamples = (sample.samples && sample.samples[cat]) || [];
    } else {
      currentSamples = sample.samples || [];
    }

    return (
      <Modal open={open} toggle={() => {}} size="lg" className="seo-sample-modal">
        <ModalHeader toggle={this.closeSample}>{sample.title}</ModalHeader>
        <ModalBody>
          {sample.desc && <p className="seo-sample-modal__desc">{sample.desc}</p>}

          {sample.byCategory && (
            <div className="seo-sample-cats">
              <div className="seo-sample-cats__label">쇼핑몰 카테고리</div>
              <div className="seo-sample-cats__list">
                {SHOP_CATEGORIES.map(c => (
                  <button key={c.key} type="button"
                          className={`seo-sample-cat${this.selectedSampleCategory === c.key ? ' is-active' : ''}`}
                          onClick={() => { this.selectedSampleCategory = c.key; }}>
                    {c.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="seo-sample-list">
            {currentSamples.length === 0 ? (
              <div className="seo-sample-empty">선택한 카테고리에 샘플이 없습니다.</div>
            ) : currentSamples.map((item, idx) => (
              <div key={idx} className="seo-sample-item">
                <div className="seo-sample-item__head">
                  <span className="seo-sample-item__label">{item.label}</span>
                  <div className="seo-sample-item__actions">
                    <Button size="sm" theme="light" onClick={() => this.copySample(item.value)}>
                      <FeatherIcon icon="copy" size="12"/> 복사
                    </Button>
                    <Button size="sm" theme="primary" onClick={() => this.applySample(field, item.value)}>
                      <FeatherIcon icon="check" size="12"/> 이 샘플 적용
                    </Button>
                  </div>
                </div>
                {isMultiline(item.value) ? (
                  <pre className="seo-sample-item__code">{item.value}</pre>
                ) : (
                  <div className="seo-sample-item__inline">{item.value}</div>
                )}
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button theme="secondary" onClick={this.closeSample}>닫기</Button>
        </ModalFooter>
      </Modal>
    );
  };

  render() {
    const score = this.scoreLevel;
    const summary = this.auditSummary;
    const sections = [
      {key: 'basic', label: '기본 정보', icon: 'file-text'},
      {key: 'search', label: '검색엔진 등록', icon: 'search'},
      {key: 'sns', label: 'SNS 공유 (OG)', icon: 'share-2'},
      {key: 'robots', label: '검색로봇 제어', icon: 'shield'},
      {key: 'redirect', label: '리다이렉션', icon: 'corner-up-right'},
      {key: 'html', label: 'HTML 삽입', icon: 'code'}
    ];

    return (
      <div className="main-content">
        <PageTitle/>

        <div className="seo-audit-page">

          {/* 헤더 */}
          <div className="seo-header">
            <div className="seo-header__left">
              <h2 className="seo-header__title">SEO 진단/설정</h2>
              <p className="seo-header__desc">쇼핑몰의 검색엔진 최적화 상태를 진단하고 설정을 관리합니다.</p>
            </div>
            <div className="seo-header__right">
              <Button className="seo-btn seo-btn--ghost" size="sm" onClick={this.loadSettings} disabled={this.isLoading}>
                <FeatherIcon icon="refresh-cw" size="14"/> 다시 진단
              </Button>
              <Button className="seo-btn seo-btn--primary" size="sm"
                      onClick={this.saveSettings}
                      disabled={this.isSaving || this.isLoading || !this.isPaidUser}
                      title={!this.isPaidUser ? '유료 플랜 전용 기능입니다.' : ''}>
                <FeatherIcon icon="save" size="14"/> {this.isSaving ? '저장 중...' : '저장'}
              </Button>
            </div>
          </div>

          {!this.isPaidUser && (
            <div className="seo-paywall-banner">
              <FeatherIcon icon="lock" size="14"/>
              <span><strong>진단은 무료로 이용</strong>할 수 있습니다. 설정 저장 / 구글 검색 별점·리뷰 노출은 <strong>유료 플랜 전용</strong>입니다. <em>(14일 무료 체험 포함)</em></span>
              <button type="button" className="seo-paywall-banner__cta"
                      onClick={() => { window.location.href = '/inAppOrder'; }}>
                <FeatherIcon icon="credit-card" size="13"/>
                결제페이지로 이동하기
                <FeatherIcon icon="arrow-right" size="13"/>
              </button>
            </div>
          )}

          {this.isLoading ? (
            <div className="seo-loading">
              <FeatherIcon icon="loader" size="20" className="seo-spin"/>
              <span>SEO 설정을 불러오는 중...</span>
            </div>
          ) : (
            <>
              {/* 진단 점수 카드 */}
              <div className="seo-score-card">
                <div className="seo-score-card__circle" style={{borderColor: score.color}}>
                  <div className="seo-score-card__pct" style={{color: score.color}}>{score.pct}</div>
                  <div className="seo-score-card__label" style={{color: score.color}}>{score.label}</div>
                </div>
                <div className="seo-score-card__stats">
                  <div className="seo-stat">
                    <div className="seo-stat__num">{summary.passed}/{summary.total}</div>
                    <div className="seo-stat__label">통과</div>
                  </div>
                  <div className="seo-stat seo-stat--error">
                    <div className="seo-stat__num">{summary.errors}</div>
                    <div className="seo-stat__label">필수 미설정</div>
                  </div>
                  <div className="seo-stat seo-stat--warn">
                    <div className="seo-stat__num">{summary.warns}</div>
                    <div className="seo-stat__label">권장 개선</div>
                  </div>
                  <div className="seo-stat seo-stat--info">
                    <div className="seo-stat__num">{summary.infos}</div>
                    <div className="seo-stat__label">참고</div>
                  </div>
                </div>
              </div>

              {/* 진단 결과 */}
              <div className="seo-section seo-section--audit">
                <div className="seo-section__head">
                  <FeatherIcon icon="activity" size="16"/>
                  <span>진단 결과</span>
                </div>
                <div className="seo-rules">
                  {this.auditResults.map(rule => (
                    <div key={rule.key}
                         className={`seo-rule seo-rule--${rule.passed ? 'ok' : rule.severity} is-clickable`}
                         onClick={() => this.jumpToRule(rule)}
                         role="button"
                         tabIndex={0}
                         onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') this.jumpToRule(rule); }}>
                      {this.renderRuleIcon(rule)}
                      <div className="seo-rule__body">
                        <div className="seo-rule__title">{rule.label}</div>
                        {!rule.passed && <div className="seo-rule__msg">{rule.msg}</div>}
                      </div>
                      <span className="seo-rule__cta">
                        설정하러 가기
                        <FeatherIcon icon="chevron-right" size="14"/>
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* 설정 섹션 탭 */}
              <div className="seo-section-tabs">
                {sections.map(s => (
                  <button key={s.key}
                          type="button"
                          className={`seo-section-tab${this.activeSection === s.key ? ' is-active' : ''}`}
                          onClick={() => { this.activeSection = s.key; }}>
                    <FeatherIcon icon={s.icon} size="14"/>
                    <span>{s.label}</span>
                  </button>
                ))}
              </div>

              {/* 섹션별 폼 */}
              <div className="seo-section">

                {this.activeSection === 'basic' && (
                  <>
                    {this.renderTextField('common_page_title', '공통 페이지 타이틀', '브라우저 탭과 검색 결과에 표시되는 제목 (10~60자 권장)')}
                    {this.renderTextField('common_page_meta_description', '공통 페이지 메타 설명', '검색 결과 요약 문구 (50~160자 권장)', {textarea: true, rows: 3})}
                    {this.renderTextField('favicon', '파비콘 URL', '브라우저 탭 아이콘 이미지 URL')}
                    {this.renderTextField('display_group', '메인분류 명')}
                  </>
                )}

                {this.activeSection === 'search' && (
                  <>
                    {this.renderToggleField('use_google_search_console', '구글 서치 콘솔 사용')}
                    {this.renderTextField('google_search_console', '구글 서치 콘솔 인증 코드', 'meta 태그 content 값')}
                    {this.renderToggleField('use_naver_search_advisor', '네이버 서치 어드바이저 사용')}
                    {this.renderTextField('naver_search_advisor', '네이버 서치 어드바이저 인증 코드')}
                  </>
                )}

                {this.activeSection === 'sns' && (
                  <>
                    {this.renderTextField('sns_share_image', 'SNS 공유 이미지 URL', 'OpenGraph 이미지 - 카카오톡/페이스북/트위터 공유 시 미리보기')}
                    {this.renderToggleField('use_twitter_card', '트위터 카드 사용')}
                  </>
                )}

                {this.activeSection === 'robots' && (
                  <>
                    {this.renderTextField('robots_text', '검색로봇 접근 제어 (PC)', 'robots.txt 형식 — Disallow: / 입력 시 모든 검색엔진 차단', {textarea: true, rows: 6})}
                    {this.renderTextField('mobile_robots_text', '검색로봇 접근 제어 (모바일)', '모바일 robots.txt', {textarea: true, rows: 6})}
                    {this.renderToggleField('use_sitemap_auto_update', '사이트맵 자동 갱신')}
                    {this.renderToggleField('use_rss', 'RSS 피드 사용')}
                    {this.renderTextField('llms_text', 'AI 크롤러 접근 제어', 'llms.txt — ChatGPT 등 AI 크롤러 정책', {textarea: true, rows: 6})}
                  </>
                )}

                {this.activeSection === 'redirect' && (
                  <>
                    {this.renderToggleField('use_missing_page_redirect', '없는 페이지 리다이렉션 (PC)')}
                    {this.renderTextField('missing_page_redirect_url', '리다이렉션 경로 (PC)')}
                    {this.renderToggleField('mobile_use_missing_page_redirect', '없는 페이지 리다이렉션 (모바일)')}
                    {this.renderTextField('mobile_missing_page_redirect_url', '리다이렉션 경로 (모바일)')}
                  </>
                )}

                {this.activeSection === 'html' && (
                  <>
                    <div className="seo-rich-snippet-card">
                      <div className="seo-rich-snippet-card__head">
                        <FeatherIcon icon="star" size="14"/>
                        <strong>구글 검색 별점·리뷰 노출 적용</strong>
                      </div>
                      <p className="seo-rich-snippet-card__desc">
                        구글 검색 결과에 우리 쇼핑몰의 <strong>별점·리뷰 수</strong>가 함께 노출되도록 만들어주는 코드를 <code>Head HTML (PC)</code>에 자동 추가합니다.
                        클릭 한 번이면 카페24 변수가 포함된 표준 코드가 안전하게 들어갑니다.
                      </p>
                      <div className="seo-rich-snippet-card__actions">
                        <Button size="sm" theme="primary"
                                onClick={this.injectRichSnippet}
                                disabled={!this.isPaidUser}
                                title={!this.isPaidUser ? '유료 플랜 전용 기능입니다.' : ''}>
                          <FeatherIcon icon="plus" size="12"/> 별점·리뷰 검색노출 적용
                        </Button>
                        <Button size="sm" theme="light"
                                onClick={this.removeRichSnippet}
                                disabled={!this.isPaidUser}
                                title={!this.isPaidUser ? '유료 플랜 전용 기능입니다.' : ''}>
                          <FeatherIcon icon="trash-2" size="12"/> 검색노출 코드 제거
                        </Button>
                      </div>
                    </div>

                    {this.renderTextField('header_tag', 'Head HTML (PC)', '<head> 영역에 삽입되는 HTML', {textarea: true, rows: 6})}
                    {this.renderTextField('footer_tag', 'Body HTML (PC)', '<body> 하단에 삽입되는 HTML', {textarea: true, rows: 6})}
                    {this.renderTextField('mobile_header_tag', 'Head HTML (모바일)', '', {textarea: true, rows: 6})}
                    {this.renderTextField('mobile_footer_tag', 'Body HTML (모바일)', '', {textarea: true, rows: 6})}
                  </>
                )}

              </div>

              <div className="seo-footer-actions">
                <Button className="seo-btn seo-btn--primary"
                        onClick={this.saveSettings}
                        disabled={this.isSaving || !this.isPaidUser}
                        title={!this.isPaidUser ? '유료 플랜 전용 기능입니다.' : ''}>
                  <FeatherIcon icon="save" size="14"/> {this.isSaving ? '저장 중...' : '설정 저장'}
                </Button>
              </div>
            </>
          )}

          {this.renderSampleModal()}

        </div>
      </div>
    );
  }
}

export default SeoAudit;
